'use strict';

const Translator = require('./../../../core/translator');
const ContentManager = require('./../component/ContentManager');

module.exports.onMenu = function(config) {
    let content = config.content;
    let rootContentSet = ContentManager.getRootContentSet();
    let forbiddenPlugins = content.getForbiddenPlugins();

    if (content.getProperties('is_image')) {
        config.add(Translator.translate('choose_picture'), 'image', 1, 'choose-image-content', '', false, {
            'content': content,
        });
    }

    if (!forbiddenPlugins.find((plugin) => plugin === 'remove')) {
        config.add(Translator.translate('delete'), 'trash-o', 10, 'delete-content', '', false, {
            'content': content,
        });
    }

    if (!forbiddenPlugins.find((plugin) => plugin === 'parameter')) {
        config.add(Translator.translate('configure'), 'setting', 20, 'configure-content', '', false, {
            'content': content,
        });
    }

    if (content.isRteEditable() && !content.getProperties('is_image')) {
        config.add(Translator.translate('edit'), 'pencil', 30, 'rte-content', '', false, {
            'content': content,
        });
    }

    if (rootContentSet.$.children('.bb-content').length > 1 && !forbiddenPlugins.find((plugin) => plugin === 'dnd')) {
        config.add(Translator.translate('move'), 'arrows', 40, 'move-content', '', false, {
            'content': content,
        });
    }
};
